<div (click)="clearStorage()" class="logo">
  <img src="/assets/svg/7n-logo 1.svg" />
  <h4>AGENT<b>HUB</b></h4>
</div>
